interface LoginRedirectLocation {
  pathname: string;
  search: string;
  hash: string;
  replace: (url: string) => void;
}

let pendingLoginUrl: string | null = null;

export function buildLoginUrl(location: Pick<LoginRedirectLocation, 'pathname' | 'search' | 'hash'>): string | null {
  if (location.pathname === '/login') return null;

  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  return returnTo === '/'
    ? '/login'
    : `/login?returnTo=${encodeURIComponent(returnTo)}`;
}

export function redirectToLogin(location: LoginRedirectLocation = window.location): void {
  const loginUrl = buildLoginUrl(location);
  if (!loginUrl || pendingLoginUrl === loginUrl) return;

  pendingLoginUrl = loginUrl;
  location.replace(loginUrl);
}

export function clearPendingLoginRedirect(): void {
  pendingLoginUrl = null;
}